// import type { RequestVM } from '@/types/filter';
import type { SideMenuProject } from '@/types/project';
import type {
  HolidaySP,
  TaskTimeTeams,
  VacationsRequestByIdModel,
  VacationsRequestSP,
} from '@/types/vacations';
import type {
  CapacityTrackerSP,
  DashboardCapacitySettings,
  TaskTimeAsignedTo,
} from '@/types/capacityTracker';
import { apiService } from '@services/api';
import type { Position } from '@/types/person';

class CapacityTrackerService
{
  static async getVacationRequestByIds(
    params: VacationsRequestByIdModel,
  ): Promise<VacationsRequestSP[]>
  {
    try
    {
      const response = await apiService.post<VacationsRequestSP[]>(
        'VacationsRequest/GetVacationRequestByPersonIds',
        params,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async getHolidays(): Promise<HolidaySP>
  {
    try
    {
      const response = await apiService.get<HolidaySP>('VacationsRequest/GetHolidays');
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async getAllTeams(): Promise<TaskTimeTeams>
  {
    try
    {
      const response = await apiService.get<TaskTimeTeams>('TaskTimeTracking/GetAll');
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  // static getAllProject(request: RequestVM): Promise<SideMenuProject>
  // {
  //    try {
  //         const response = apiService.post<SideMenuProject>('Project/GetSideMenuProjects');
  //         return response
  //     } catch (error) {
  //         console.error('Error setting sp:', error);
  //         throw error;
  //     }
  // }

  static async getAllProject(): Promise<{ TotalCount: number; Projects: SideMenuProject[] }>
  {
    try
    {
      const response = await apiService.post<{ TotalCount: number; Projects: SideMenuProject[] }>(
        '/Project/GetSideMenuProjects',
        {
          GroupByDetailId: 0,
          GroupByLayerId: 0,
          GroupByValueField: '',
        },
      );
      return response;
    }
    catch (error)
    {
      console.error('Error getting side menu projects:', error);
      throw error;
    }
  }

  static async getDashboardsByProjectIds(projectId: string)
  {
    try
    {
      const response = await apiService.get(
        `dashboard/GetDashboardsByProjectId?projectIds=${projectId}`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async getCapacityTrackerByDashboard(dashboardId: string): Promise<CapacityTrackerSP>
  {
    try
    {
      const response = apiService.get<CapacityTrackerSP>(
        `dashboard/GetCapacityTracker?dashboardId=${dashboardId}`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async getAllAssignedTo(requestConfig: any)
  {
    try
    {
      const response = await apiService.get(
        `TaskTimeTracking/GetAllAsigned?teams=${requestConfig.Teams}&getTeamId=${requestConfig.GetTeamId}&getDepartmentId=${requestConfig.GetDepartmentId}&getPositionId=${requestConfig.GetPositionId}&getAllPeople=${requestConfig.GetAllPeople}`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async getPositions(): Promise<Position[]>
  {
    try
    {
      const response = await apiService.get<Position[]>(`Positions/GetPositions`);
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async getDashboardCapacitySettings(
    dashboardId: string,
  ): Promise<DashboardCapacitySettings>
  {
    try
    {
      const response = await apiService.get<DashboardCapacitySettings>(
        `dashboard/GetDashboardCapacitySettings?dashboardId=${dashboardId}`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async updateDashboardCapacitySettings(request: any)
  {
    try
    {
      const response = await apiService.post(`dashboard/UpdateDashboardCapacitySettings`, request);
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  // static async getVacationRequestByIds(request: VacationsRequestByIdModelRequest)
  // {
  //     try {
  //         const response = await apiService.post(`VacationsRequest/GetVacationRequestByPersonIds`, request);
  //         return response;
  //     } catch (error) {
  //         console.error('Error setting sp:', error);
  //         throw error;
  //     }
  // }

  static async getAllAsignedTo(request: {
    Teams: string;
    GetTeamId: boolean;
    GetDepartmentId: boolean;
    GetPositionId: boolean;
    GetAllPeople: boolean;
  }): Promise<TaskTimeAsignedTo[]>
  {
    try
    {
      const response = await apiService.get<TaskTimeAsignedTo[]>(
        `TaskTimeTracking/GetAllAsigned?teams=${request.Teams}&getTeamId=${request.GetTeamId}&getDepartmentId=${request.GetDepartmentId}&getPositionId=${request.GetPositionId}&getAllPeople=${request.GetAllPeople}`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }
}

export default CapacityTrackerService;
